<h2 mat-dialog-title>{{ data.title }}</h2>
<p *ngFor="let paragraph of descriptionParagraphs">
  {{ paragraph }}
</p>
<p class="warning" *ngIf="hasWarning()">{{ data.warning }}</p>
<mat-dialog-content>
  <mat-form-field>
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Add a comment"
      [formControl]="inputComment"
      [required]="data.commentRequired"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" color="primary">CANCEL</button>
  <button mat-flat-button (click)="confirmAndClose()" color="primary" [disabled]="!inputComment.valid">
    {{ actionButtonText() }}
  </button>
</mat-dialog-actions>
